import Cookies from "js-cookie";
import { Fancybox } from "@fancyapps/ui";

Fancybox.bind("[data-fancybox]", {
  // Your custom options
});
jQuery(function ($) {
  var SPLASH = "splash_cookie";

  // Check if the splash cookie does not exist and #splash-content exists
  if (Cookies.get(SPLASH) === undefined && $("#splash-content").length > 0) {
    // Open Fancybox programmatically for #splash-content
    Fancybox.show([{ src: "#splash-content", type: "inline" }], {
      on: {
        // Listen for the 'close' event
        close: (fancybox, slide) => {
          // Set a cookie when this specific Fancybox is closed
          Cookies.set(SPLASH, "done", { path: "/", expires: 14 });
          console.log("Fancybox has been closed and cookie set.");
        },
      },
    });
  }

  // Handle click event on the link with the class "button"
  $("#splash-content .button").on("click", function (e) {
    Cookies.set(SPLASH, "done", { path: "/", expires: 14 });
  });
});

// jQuery(function ($) {

// var COOKIE_NOTICE = 'cookie-notice';
// $gonotice = $.cookie(COOKIE_NOTICE);

// if ($gonotice == null) {
//     setTimeout(function(){
//         $('.cookie').addClass('show');

//     }, 500);

// }

// $('.accept').on('click',function(){
//     // window['ga-disable-GTM-TD8R8NH'] = false;
//     $.cookie(COOKIE_NOTICE, 'done', { path: '/', expires: 14 });
//     $('.cookie').removeClass('show');
//     // window.dataLayer = window.dataLayer || [];
//     // function gtag(){dataLayer.push(arguments);}
//     // gtag('js', new Date());
//     // gtag('config', 'GTM-TD8R8NH');
// });

// $('#remove').on('click', function() {
//     let cookies = document.cookie.split(';');
//     for (let i = 0; i <cookies.length;i++){
//         let cookie = cookies[i];
//         let eqPos = cookie.indexOf("=");
//         let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
//         document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.lws-servers.be";
//     }
//     // window['ga-disable-GTM-TD8R8NH'] = true;
//     $.cookie(COOKIE_NOTICE, 'done', { path: '/', expires: 14 });
//     $('.cookie').removeClass('show');
// })
// });
